import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";

import Button from "../../Button";
import Modal from "../../Modal";

const ConfirmPublishPlaygroundModal = forwardRef(({ onSubmit, isLoading }, ref) => {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    openModal() {
      setIsOpen(true);
    },
    closeModal() {
      setIsOpen(false);
    },
  }));

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  const handleConfirm = () => {
    onSubmit();
  };

  return (
    <Modal
      footer={
        <div className="flex items-center justify-end space-x-2">
          <Button
            color="white"
            variant="outlined"
            onClick={handleCloseModal}
            label={t("cancel")}
            className="w-28"
          />
          <Button
            label={t("publish")}
            onClick={handleConfirm}
            loading={isLoading}
            disabled={isLoading}
            className="w-32"
          />
        </div>
      }
      isOpen={isOpen}
      onClose={handleCloseModal}
      className="w-full max-w-2xl"
    >
      <h3 className="text-lg font-semibold text-blue-500">{t("confirm_submit")}</h3>
      <p className="mt-4 text-lg font-light text-blue-500">
        {t("are_you_sure_submit")}
        <strong>{t("question_mark")}</strong>
      </p>
    </Modal>
  );
});

export default ConfirmPublishPlaygroundModal;
